import { PortalBlock } from '@nx-frontend/shared/types/portal-block';

interface CalcNewBlockIndexProps {
  blocks: PortalBlock[];
}

export const calcNewBlockIndex = ({ blocks }: CalcNewBlockIndexProps) => {
  const maxIndex = blocks.reduce(
    (max, block) => (block.ghost !== true && block.index < 999 ? Math.max(max, block.index) : max),
    0
  );
  return maxIndex + 1;
};
